"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8784],{

/***/ 90129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58586);
/* harmony import */ var _pairy_pds_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61810);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52903);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var BlurredCompactItem = function BlurredCompactItem(_ref) {
  var children = _ref.children,
      onUpgradeClick = _ref.onUpgradeClick,
      _ref$showBorder = _ref.showBorder,
      showBorder = _ref$showBorder === void 0 ? false : _ref$showBorder,
      _ref$borderRadius = _ref.borderRadius,
      borderRadius = _ref$borderRadius === void 0 ? 8 : _ref$borderRadius;
  var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__.u)();
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("div", {
    style: _objectSpread({
      position: 'relative'
    }, showBorder && {
      border: "1px solid ".concat(theme.colors.zinc_200),
      borderRadius: borderRadius,
      overflow: 'hidden'
    }),
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
      style: {
        filter: 'blur(6px)',
        opacity: 0.6,
        pointerEvents: 'none',
        userSelect: 'none'
      },
      "aria-hidden": true,
      children: children
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
      style: {
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer'
      },
      onClick: onUpgradeClick,
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_pairy_pds_react__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO, {
        icon: "ph:lock-fill",
        size: 20,
        color: "zinc_400"
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (BlurredCompactItem);

/***/ }),

/***/ 41641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_DeleteConfirmModal; }
});

// EXTERNAL MODULE: ../../packages/pds-react/src/index.ts + 66 modules
var src = __webpack_require__(61810);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(36557);
;// CONCATENATED MODULE: ./components/User/_components/common/DeleteConfirmModal/index.styles.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e8wwsth1"
} : 0)("display:flex;flex-direction:column;background:", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.white;
}, ";gap:24px;" + ( true ? "" : 0));
var ButtonsWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e8wwsth0"
} : 0)( true ? {
  name: "1paj4fk",
  styles: "display:flex;justify-content:flex-end;gap:8px;&>button{flex:1;}"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./components/User/_components/common/DeleteConfirmModal/index.tsx





var DeleteConfirmModal = function DeleteConfirmModal(_ref) {
  var isOpen = _ref.isOpen,
      setIsOpen = _ref.setIsOpen,
      onClick = _ref.onClick,
      loading = _ref.loading,
      content = _ref.content,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '삭제 확인' : _ref$title,
      _ref$confirmText = _ref.confirmText,
      confirmText = _ref$confirmText === void 0 ? '삭제하기' : _ref$confirmText;

  var handleCancelButtonClick = function handleCancelButtonClick(e) {
    e.stopPropagation();
    setIsOpen(false);
  };

  var handleDeleteButtonClick = function handleDeleteButtonClick(e) {
    e.stopPropagation();
    onClick();
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Modal.Root */.u_.Root, {
    open: isOpen,
    onOpenChange: setIsOpen,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Modal.Content */.u_.Content, {
      loading: loading,
      onClick: function onClick(e) {
        return e.stopPropagation();
      },
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Modal.Header */.u_.Header, {
        title: title
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Modal.Body */.u_.Body, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            children: content
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ButtonsWrapper, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
              variant: "zinc_200",
              textVariant: "lg-semibold",
              paddingY: 16,
              paddingX: 24,
              onClick: handleCancelButtonClick,
              children: "\uCDE8\uC18C"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
              variant: "cerise_400_fill",
              textVariant: "lg-semibold",
              paddingY: 16,
              paddingX: 24,
              onClick: handleDeleteButtonClick,
              children: confirmText
            })]
          })]
        })
      })]
    })
  });
};

/* harmony default export */ var common_DeleteConfirmModal = (DeleteConfirmModal);

/***/ }),

/***/ 79701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36557);


var NavHeader = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e14jt0590"
} : 0)("padding-bottom:8px;border-bottom:1px solid ", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.zinc_200;
}, ";margin-bottom:16px;" + ( true ? "" : 0));

/* harmony default export */ __webpack_exports__["Z"] = (NavHeader);

/***/ }),

/***/ 13442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_Navigation; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(8529);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(12524);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(36557);
// EXTERNAL MODULE: ../../packages/pds-react/src/index.ts + 66 modules
var src = __webpack_require__(61810);
;// CONCATENATED MODULE: ./components/User/_components/common/Navigation/index.styles.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var Ul = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "e1ig7oc44"
} : 0)( true ? {
  name: "15ytwx8",
  styles: "position:relative;display:inline-flex;align-items:flex-start;padding:0;border-radius:8px;gap:8px"
} : 0);
var NavButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ig7oc43"
} : 0)("display:flex;align-items:center;padding:8px 16px;border:1px solid ", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.transparent;
}, ";border-radius:8px;color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.black;
}, ";cursor:pointer;gap:8px;opacity:0.5;transition:all 0.15s ease-in-out;&.active{background-color:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.black;
}, ";color:", function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.white;
}, ";opacity:1;}&.disabled{background-color:", function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.zinc_200;
}, ";color:", function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.zinc_400;
}, ";}&:hover{opacity:1;}" + ( true ? "" : 0));
var A = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("a",  true ? {
  target: "e1ig7oc42"
} : 0)("display:flex;align-items:center;padding:8px 16px;border:1px solid ", function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.transparent;
}, ";border-radius:8px;color:", function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.black;
}, ";cursor:pointer;gap:8px;opacity:0.5;transition:all 0.15s ease-in-out;&[data-state='active']{background-color:", function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.black;
}, ";color:", function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.white;
}, ";opacity:1;}&:hover{opacity:1;}" + ( true ? "" : 0))));
var LinkIcon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Icon */.JO,  true ? {
  target: "e1ig7oc41"
} : 0)( true ? {
  name: "hhtc7e",
  styles: "opacity:inherit"
} : 0);
var Name = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Text */.xv,  true ? {
  target: "e1ig7oc40"
} : 0)( true ? {
  name: "hhtc7e",
  styles: "opacity:inherit"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./components/User/_components/common/Navigation/index.tsx









var Navigation = function Navigation(_ref) {
  var navigations = _ref.navigations;
  var router = (0,next_router.useRouter)();
  var routerQueryToString = (0,react.useMemo)(function () {
    return Object.entries(router.query).map(function (_ref2, index) {
      var _ref3 = (0,slicedToArray/* default */.Z)(_ref2, 2),
          key = _ref3[0],
          value = _ref3[1];

      if (index === 0) {
        return "?".concat(key, "=").concat(value);
      }

      return "&".concat(key, "=").concat(value);
    }).join('');
  }, [router.query]);

  var isCurrentPage = function isCurrentPage(route) {
    return router.pathname.includes(route);
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("nav", {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Ul, {
      children: navigations.map(function (_ref4) {
        var name = _ref4.name,
            icon = _ref4.icon,
            route = _ref4.route,
            id = _ref4.id,
            _onClick = _ref4.onClick,
            isDisabled = _ref4.isDisabled,
            className = _ref4.className;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
          id: id,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
            href: "".concat(route).concat(routerQueryToString),
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NavButton, {
              className: classnames_default()(className, {
                active: isCurrentPage(route),
                disabled: isDisabled
              }),
              onClick: function onClick(e) {
                if (_onClick) {
                  _onClick(e);
                }
              },
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkIcon, {
                icon: icon,
                size: 24
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Name, {
                variant: "lg-semibold",
                color: 'inherit',
                children: name
              })]
            })
          })
        }, name);
      })
    })
  });
};

/* harmony default export */ var common_Navigation = (Navigation);

/***/ }),

/***/ 94731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _pairy_pds_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61810);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52903);





var PaywalledBlur = function PaywalledBlur(_ref) {
  var children = _ref.children,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Pro 플랜 이상에서 확인할 수 있어요' : _ref$title,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? '국가별 열람 통계로 해외/국내 리드 반응을 비교해보세요.' : _ref$description,
      onUpgradeClick = _ref.onUpgradeClick;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)("div", {
    style: {
      position: 'relative',
      minHeight: 150
    },
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", {
      style: {
        filter: 'blur(6px)',
        opacity: 0.6,
        pointerEvents: 'none',
        userSelect: 'none',
        minHeight: 150
      },
      "aria-hidden": true,
      children: children
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", {
      style: {
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16
      },
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", {
        style: {
          width: '100%',
          maxWidth: 420,
          borderRadius: 12,
          background: 'rgba(255,255,255,0.92)',
          backdropFilter: 'blur(6px)',
          padding: 16,
          boxShadow: '0 10px 30px rgba(0,0,0,0.10)'
        },
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_pairy_pds_react__WEBPACK_IMPORTED_MODULE_1__/* .Stack */ .Kq, {
          gap: 12,
          direction: 'column',
          alignItems: 'center',
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_pairy_pds_react__WEBPACK_IMPORTED_MODULE_1__/* .Stack */ .Kq, {
            gap: 8,
            direction: 'column',
            alignItems: 'center',
            children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_pairy_pds_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
              variant: "lg-semibold",
              children: title
            }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_pairy_pds_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
              variant: "sm-medium",
              color: "zinc_600",
              children: description
            })]
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_pairy_pds_react__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
            variant: "skyblue_400",
            leftIcon: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_pairy_pds_react__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .JO, {
              icon: "ph:magic-wand-fill",
              size: 19
            }),
            onClick: onUpgradeClick,
            width: '100%',
            children: "\uC5C5\uADF8\uB808\uC774\uB4DC\uD558\uACE0 \uD655\uC778\uD558\uAE30"
          })]
        })
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (PaywalledBlur);

/***/ }),

/***/ 77991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ slideUp; },
/* harmony export */   "q": function() { return /* binding */ slideDown; }
/* harmony export */ });
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28165);

var slideDown = function slideDown(height) {
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_0__/* .keyframes */ .F4)({
    from: {
      height: 0
    },
    to: {
      height: height
    }
  });
};
var slideUp = function slideUp(height) {
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_0__/* .keyframes */ .F4)({
    from: {
      height: height
    },
    to: {
      height: 0
    }
  });
};

/***/ }),

/***/ 98819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CN": function() { return /* binding */ formatPhone; },
/* harmony export */   "Wr": function() { return /* binding */ stripPhone; },
/* harmony export */   "s$": function() { return /* binding */ formatKoreanPhoneNumber; }
/* harmony export */ });
/* unused harmony export normalizePhone */
/** 숫자만 추출 (서버 전송 시 사용) */
function normalizePhone(phone) {
  if (!phone) {
    return null;
  }

  var normalized = phone.replace(/\D/g, '');
  return normalized || null;
}
/**
 * 저장된 전화번호를 표시용으로 포맷 (완성된 번호 대상)
 *
 * 1. 010-XXXX-XXXX : 11자리 휴대폰
 * 2. 010-XXX-XXXX  : 10자리 휴대폰 (구형)
 * 3. 02-XXXX-XXXX  : 10자리 서울 지역번호
 * 4. 031-XXX-XXXX  : 10자리 서울 외 지역번호
 * 5. 1688-XXXX     : 8자리 대표번호
 */

function formatKoreanPhoneNumber(phone) {
  var normalized = normalizePhone(phone);

  if (!normalized) {
    return '';
  } // 11자리: 010-XXXX-XXXX


  if (normalized.length === 11) {
    return normalized.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
  } // 8자리: 1688-XXXX


  if (normalized.length === 8) {
    return normalized.replace(/(\d{4})(\d{4})/, '$1-$2');
  } // 02로 시작: 02-XXXX-XXXX


  if (normalized.startsWith('02')) {
    return normalized.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3');
  } // 나머지 10자리: 031-XXX-XXXX / 010-XXX-XXXX


  var result = normalized.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
  return result !== normalized ? result : normalized;
}
/** 서버 전송 시 하이픈 제거 (normalizePhone alias) */

var stripPhone = function stripPhone(value) {
  var _normalizePhone;

  return (_normalizePhone = normalizePhone(value)) !== null && _normalizePhone !== void 0 ? _normalizePhone : value;
};
/**
 * 입력 필드에서 실시간 포맷 (타이핑 중 사용)
 * - 완성 시점에 formatKoreanPhoneNumber와 동일한 패턴으로 확정
 */

var formatPhone = function formatPhone(value) {
  var digits = value.replace(/\D/g, ''); // 서울 지역번호: 02-XXXX-XXXX (10자리)

  if (digits.startsWith('02')) {
    var _sliced = digits.slice(0, 10);

    if (_sliced.length <= 2) {
      return _sliced;
    }

    if (_sliced.length <= 6) {
      return _sliced.replace(/(\d{2})(\d+)/, '$1-$2');
    } // 7–9자리 중간: 2-4-X


    if (_sliced.length <= 9) {
      return _sliced.replace(/(\d{2})(\d{4})(\d+)/, '$1-$2-$3');
    } // 10자리 완성: 02-XXXX-XXXX


    return _sliced.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3');
  } // 대표번호: 1688-XXXX 등 (0으로 시작하지 않는 최대 8자리)


  if (!digits.startsWith('0')) {
    var _sliced2 = digits.slice(0, 8);

    if (_sliced2.length <= 4) {
      return _sliced2;
    }

    return _sliced2.replace(/(\d{4})(\d+)/, '$1-$2');
  } // 휴대폰·지역번호


  var sliced = digits.slice(0, 11);

  if (sliced.length <= 3) {
    return sliced;
  }

  if (sliced.length <= 7) {
    return sliced.replace(/(\d{3})(\d+)/, '$1-$2');
  } // 8–9자리 중간: 3-3-X


  if (sliced.length <= 9) {
    return sliced.replace(/(\d{3})(\d{3})(\d+)/, '$1-$2-$3');
  } // 10자리 완성: 031-XXX-XXXX / 010-XXX-XXXX (3-3-4)


  if (sliced.length === 10) {
    return sliced.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
  } // 11자리 완성: 010-XXXX-XXXX (3-4-4)


  return sliced.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
};

/***/ })

}]);